import { SidebarMenuItem } from './SidebarMenuItem'
import { useAuth } from "../../../../../app/modules/auth"

import { ApplicantSidebarMenu } from '../../../../../app/modules/company/layout/ApplicantSidebarMenu'
import { UserSidebarMenu } from '../../../../../app/modules/setsco/layout/UserSidebarMenu'

const SidebarMenuMain = () => {
    
    const {currentUser} = useAuth()    

    if (! (currentUser)) {
        return (
        <>
        <SidebarMenuItem
            to='/ccs'        
            title="Certificate of Conformity" 
            fontIcon='bi-archive'
            icon='/media/icons/duotune/abstract/abs037.svg'
        />
        <SidebarMenuItem
            to='/sld'        
            title="Serial Labels" 
            fontIcon='bi-archive'
            icon='/media/icons/duotune/abstract/abs037.svg'
        />
        </>
        )
    }
        
    return (currentUser.isSetsco) ? <UserSidebarMenu /> : <ApplicantSidebarMenu />;    
}

export {SidebarMenuMain}
